export default __webpack_public_path__ + "static/media/icon-close-color-primary.2b479760.svg";